import clsx from 'clsx';
import { ProductUSPItem } from '~/features/product-details/components/ProductOverview/components/ProductUSPItem/ProductUSPItem';
import { usePDPData } from '~/features/product-details/context';
import { SalesforceProductPromotionType } from '~/lib/salesforce/types';
import { hasPromotionType } from '~/lib/salesforce/utilities/prices';
import { isFreightByCarrier } from '~/lib/salesforce/utilities/shipping';
import { RawHtml } from '~/shared/components';
import { useFrame } from '~/shared/utils';
import styles from './ProductUSP.module.scss';

export const ProductUSP: React.FC<React.HTMLAttributes<HTMLUListElement>> = ({
    className,
    ...rest
}) => {
    const { data: frame } = useFrame();
    const { product } = usePDPData();

    const usp = frame.market.uniqueSellingPoints;

    const hasChristmasPrice = hasPromotionType(
        product.c_prices,
        SalesforceProductPromotionType.CHRISTMAS_PRICE,
    );

    if (!usp?.length) return null;

    return (
        <ul className={clsx(styles.usp, className)} {...rest}>
            {usp.map((entry, index) => {
                const { tags, text: richText, icon, tooltip } = entry;

                const hasFreightByCarrierTag = tags.includes('freightByCarrier');

                // We will not render the 'freightByCarrier' USP if the product's freight is by carrier.
                if (hasFreightByCarrierTag && isFreightByCarrier(product.c_itemFreightGroup))
                    return null;

                const hasChristmasPriceTag = tags.includes('christmasprice');

                // We will not render the 'christmasprice' USP if the product doesn't have Christmas price promotion.
                if (hasChristmasPriceTag && !hasChristmasPrice) return null;

                // All other USP will be rendered.
                return (
                    <ProductUSPItem
                        className={styles.uspItem}
                        key={`usp-${index}`}
                        as="li"
                        icon={icon}
                        label={<RawHtml html={richText} />}
                        tooltip={tooltip}
                    />
                );
            })}
        </ul>
    );
};
